import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  triggerName: 'owner',
  namespace: 'OWNER',
  entryPoint: '/owners',
  collectionName: 'owners',
  querySearchListing: [
    ['name', ['entity', ['primary_email', 'primary_phone'] ]],
    { order: { id: 'asc' } }
  ],
  quickSearch: (keyword) => ({ $any: [{ name: { match: keyword } }, { 'entity.primary_email': { match: keyword } }] }),
  successMessageCreate: 'Owner created',
  successMessageUpdate: 'Owner updated',
  successMessageDelete: 'Owner deleted',
});

export default {
  ...triggers,
  submitOwner(dispatch, getState, { objectData, id }) {
    const { entity_data, ...data } = objectData;
    const entitiesCollectionName = data.entity.value[0];
    data.relations = { [entitiesCollectionName]: [entity_data] };
    return !id
      ? triggers.submitCreateForm(dispatch, getState, data)
      : triggers.submitEditForm(dispatch, getState, { id, objectData: data });
  }
};



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/owner/triggers.js